import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import copyToClipboard from '../../utils/copyToClipboard';
import generateShareLink from '../../utils/shareLink';
import { useApi } from '../../context/ApiProvider';
import { Button, CircularProgress } from '@mui/material';
import { Share } from '@mui/icons-material';

const ShareButton = ({
  id,
  artistName,
  isTrack,
  trackName,
  isArtist,
  size = 'large',
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const api = useApi();
  const [isGenerating, setIsGenerating] = useState(false);
  const domain = window.location.origin;

  async function shareItem() {
    if (isArtist) {
      copyArtist();
    } else if (isTrack) {
      await copyTrack();
    } else {
      await copySet();
    }
  }

  async function copySet() {
    setIsGenerating(true);
    const setLink = await generateShareLink('set', id, api);
    if (setLink) {
      const setMessage = `Check out this set by ${artistName} on KIP: `;
      copyToClipboard(setMessage, setLink, 'Set', enqueueSnackbar);
    } else {
      // Fallback to non-tracked link if generation fails
      const fallbackLink = `https://api.kip.audio/public/preview/sets/${id}`;
      const setMessage = `Check out this set by ${artistName} on KIP: `;
      copyToClipboard(setMessage, fallbackLink, 'Set', enqueueSnackbar);
    }
    setIsGenerating(false);
  }

  async function copyTrack() {
    setIsGenerating(true);
    const trackLink = await generateShareLink('track', id, api);
    if (trackLink) {
      const message = `Check out ${trackName} by ${artistName} on KIP: `;
      copyToClipboard(message, trackLink, 'Track', enqueueSnackbar);
    } else {
      // Fallback to non-tracked link if generation fails
      const fallbackLink = `https://api.kip.audio/public/preview/tracks/${id}`;
      const message = `Check out ${trackName} by ${artistName} on KIP: `;
      copyToClipboard(message, fallbackLink, 'Track', enqueueSnackbar);
    }
    setIsGenerating(false);
  }

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={shareItem}
      size={size}
      disabled={isGenerating}
      startIcon={
        size === 'small' ? null : isGenerating ? (
          <CircularProgress size={16} color="inherit" />
        ) : (
          <Share />
        )
      }
      sx={{
        borderLeft: '1px solid',
        position: 'relative',
        ...(size === 'small' ? { minWidth: 'auto', px: 1 } : {}),
      }}
    >
      {size === 'small' ? (
        isGenerating ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          <Share />
        )
      ) : (
        'Share'
      )}
    </Button>
  );
};

ShareButton.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  artistName: PropTypes.string,
  trackName: PropTypes.string,
  isTrack: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default ShareButton;
